import { render, staticRenderFns } from "./BPAccrualsModule.vue?vue&type=template&id=2f474327&"
import script from "./BPAccrualsModule.vue?vue&type=script&lang=js&"
export * from "./BPAccrualsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports